import { createReducer } from '@reduxjs/toolkit';

import { SatelliteManager, Loadable } from 'models';
import { makeThunkFromAPICall } from 'state';

export type SatellitesState = {
    list: Loadable<SatelliteManager.Satellite[]>;
};

const initialState: SatellitesState = {
    list: { status: 'idle' },
};

export const [getSatellite, setSatellite] = makeThunkFromAPICall(
    SatelliteManager.getSatelliteById,
    'Satellites/get',
);

export const [getSatelliteList, setSatelliteList] = makeThunkFromAPICall(
    SatelliteManager.listSatellites,
    'Satellites/list',
);

export const satellitesReducer = createReducer(initialState, (builder) => {
    builder.addCase(setSatelliteList, (state, action) => {
        return {
            ...state,
            list: { ...state.list, ...action.payload.loadable },
        };
    });
});

export const satellitesActions = {
    getSatelliteList,
    setSatelliteList,
    getSatellite,
};

export default satellitesReducer;
